import * as React from "react";
import { useTranslation } from "react-i18next";
import MetricsExtractor from "logic/metrics/MetricsExtractor";
import { useMetric } from "hooks/useMetrics";
const MetricContainer = ({ name, zeroOnMissing = true, children }) => {
  const { t } = useTranslation("system");
  const { data: metrics, isLoading } = useMetric(name);
  if (isLoading || Object.keys(metrics).length === 0) {
    return /* @__PURE__ */ React.createElement("span", null, t("metric_container.loading"));
  }
  let throughput = Object.keys(metrics).map((nodeId) => MetricsExtractor.getValuesForNode(metrics[nodeId], { throughput: name })).reduce(
    (accumulator, currentMetric) => ({ throughput: (accumulator.throughput || 0) + (currentMetric.throughput || 0) }),
    {}
  );
  if (zeroOnMissing && (!throughput || !throughput.throughput)) {
    throughput = { throughput: 0 };
  }
  return /* @__PURE__ */ React.createElement("div", null, React.Children.map(
    children,
    (child) => React.cloneElement(child, { metric: { full_name: name, count: throughput.throughput } })
  ));
};
export default MetricContainer;
